const routeGroup = [
    {
        path: '/',
        redirect: {
            name: 'groupDashboard'
        }
    },

    /* -------------------------------- DASHBOARD ------------------------------- */
    {
        path: 'dashboard',
        name: 'groupDashboard',
        component: () => import('../views/group/dashboard/index.vue'),
        meta: {
            pagePermission: 'dashboard.index'
        }
    },

    /* -------------------------------- TRANSACTION ------------------------------- */
    {
        path: 'report/determination',
        name: 'groupDetermination',
        component: () => import('../views/group/determination/index.vue'),
        meta: {
            pagePermission: 'determination.index'
        }
    },
    
    /* -------------------------------- TRANSACTION ------------------------------- */
    {
        path: 'report/transaction',
        name: 'groupTransaction',
        component: () => import('../views/group/transaction/index.vue'),
        meta: {
            pagePermission: 'transaction.index'
        }
    },
        
    /* -------------------------------- SUMMARY ------------------------------- */
    {
        path: 'report/summary',
        name: 'groupSummary',
        component: () => import('../views/group/summary/index.vue'),
        meta: {
            pagePermission: 'summary.index'
        }
    }
]

export default routeGroup